import { useState, useEffect, useCallback, useMemo } from "react";
import { get } from "../services/Services";

export const useGet = (url, config = {}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Memoriza el objeto config para evitar recreaciones innecesarias
  const memoizedConfig = useMemo(() => config, [JSON.stringify(config)]);

  // Definir la función `fetchData` con `useCallback`
  const fetchData = useCallback(async () => {
     if (!url) return; 
    setLoading(true);
    try {
      const response = await get(url, memoizedConfig);
      setData(response.data);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [url, memoizedConfig]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading, refetch: fetchData };
};
